import React from 'react';
import Resources from '../Resources';
import SocialLinks from '../SocialLinks';
import styles from './styles.module.scss';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const ArticleFooter = _ref => {
  let {
    authors = [],
    citations = []
  } = _ref;
  const hasAuthors = authors.length > 0;
  const hasCitations = citations.length > 0;
  return /*#__PURE__*/_jsxs("footer", {
    className: styles.container,
    children: [hasAuthors && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("h6", {
        className: styles.heading,
        children: ["About the Author", authors.length > 0 ? 's' : '']
      }), /*#__PURE__*/_jsx("ul", {
        className: styles.list,
        children: authors.map((author, index) => {
          const certText = author.certifications ? `, ${author.certifications}` : '';
          const {
            socialUrls = []
          } = author;
          const hasSocials = socialUrls.length > 0;
          return /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsxs("a", {
              href: `/authors/${author.slug}`,
              title: `${author.fullName}'s author profile`,
              children: [Boolean(author.avatarUrl) && /*#__PURE__*/_jsx("img", {
                src: author === null || author === void 0 ? void 0 : author.avatarUrl,
                loading: "lazy",
                alt: `Author ${author.fullName}`
              }), /*#__PURE__*/_jsxs("h6", {
                children: [author.fullName, certText]
              }), /*#__PURE__*/_jsx("p", {
                children: author.articleBio || author.longBio || author.shortBio
              })]
            }), hasSocials && /*#__PURE__*/_jsx(SocialLinks, {
              className: styles.socials,
              urls: socialUrls
            })]
          }, index);
        })
      })]
    }), hasCitations && /*#__PURE__*/_jsx(Resources, {
      citations: citations
    })]
  });
};

export default ArticleFooter;